import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import ReactCountryFlag from "react-country-flag";
import _ from "lodash";
import { Translate } from "react-redux-i18n";
import Constants from "../../AppConstants/Constants";
import { logout, setAuthenticated } from "../../Store/Account/Actions";
import { setWizardInProgressData, updateWizardInProgressModalState, initializeEligibilityModal } from "../../Store/Modals/Actions";
import { getXsrfToken } from "../../Store/Security/Actions";
import { setLanguage, setCurrency } from "../../Store/Localization/Actions";
import { setSelectedDeviceProductId, setSelectedKitProductId } from "../../Store/Product/Actions";

class NavMenu extends Component {
    constructor(props) {
        super(props);

        this.onTabClick = this.onTabClick.bind(this);
        this.renderAccountOptions = this.renderAccountOptions.bind(this);
        this.logout = this.logout.bind(this);
        this.changeLanguage = this.changeLanguage.bind(this);
    }

    toggleMenu(e) {
        e.preventDefault();

        const menu = $("#menu1");
        menu.toggleClass("hidden-xs");
    }

    onTabClick(path) {
        const { tempCart, location, history, setWizardInProgressData, updateWizardInProgressModalState, setSelectedDeviceProductId, setSelectedKitProductId } = this.props;

        if ((location.pathname.includes("/kits") && (tempCart.Kit || tempCart["Shop Kits"]) && (!tempCart.Plan || !tempCart.Service)) || (location.pathname === "/devices" && tempCart.Devices && (!tempCart.Plan || !tempCart.Service))){
            const modalData = {};

            if (path === "devices") {
                modalData.url = Constants.ENDPOINTS.DEVICES;
                modalData.name = "Devices";
            } else if (path === "accessories-zebra") {
                modalData.url = Constants.ENDPOINTS.ZEBRA_ACCESSORIES;
            } else if (path === "accessories-tc26") {
                modalData.url = Constants.ENDPOINTS.ZEBRA_TC26_ACCESSORIES;
            } else if (path === "zebra-tc58-accessories") {
                modalData.url = Constants.ENDPOINTS.ZEBRA_TC58_ACCESSORIES;
            } else if (path === "zebra-tc78-accessories") {
                modalData.url = Constants.ENDPOINTS.ZEBRA_TC78_ACCESSORIES;
            } else if (path === "accessories-panasonic") {
                modalData.url = Constants.ENDPOINTS.PANASONIC_ACCESSORIES;
            } else if (path === "accessories-universal") {
                modalData.url = Constants.ENDPOINTS.UNIVERSAL_ACCESSORIES;
            } else if (path === "support") {
                modalData.url = Constants.ENDPOINTS.SUPPORT;
            } else if (path === "about/services") {
                modalData.url = Constants.ENDPOINTS.SERVICES;
            } else if (path === "about/company") {
                modalData.url = Constants.ENDPOINTS.COMPANY;
            } else if (path === "privacypolicy") {
                modalData.url = Constants.ENDPOINTS.PRIVACY_POLICY;
            } else if (path === "returnrefundpolicy") {
                modalData.url = Constants.ENDPOINTS.RETURN_REFUND_POLICY;
            } else if (path === "pending-returns") {
                modalData.url = Constants.ENDPOINTS.ADVANCED_EXCHANGE;
            } else if (path === "vtrack") {
                modalData.url = Constants.ENDPOINTS.VTRACK;
            } else if (path === "line-haul") {
                modalData.url = Constants.ENDPOINTS.LINEHAUL;
            } else if (path === "kits-shop") {
                modalData.name = "Shop Kits";
                modalData.url = Constants.ENDPOINTS.KITS;
            } else if (path === "kits-build") {
                modalData.name = "Build Kit";
                modalData.url = Constants.ENDPOINTS.BUILD_A_KIT;
            } else if (path === "") {
                modalData.url = Constants.ENDPOINTS.HOME;
            }
            setWizardInProgressData(modalData);
            updateWizardInProgressModalState(true);
        } else {
            if (path === "company" || path === "services") {
                history.push(`/about/${path}`);
            } else if (path === "returnrefundpolicy") {
                history.push(`/support/${path}`);
            } else if (path === "pending-returns") {
                history.push(`/support/${path}`)
            } else if (path === "devices") {
                history.push(`/${path}`);
                setSelectedDeviceProductId(-1);
            } else if (path === "kits-shop" || path === "kits-build") {
                history.push(`/${path}`);
                setSelectedKitProductId(-1);
            } else {
                history.push(`/${path}`);
            }
        }

        // close product details when clicking on kits tab
        // if (path === "kits-build" || path === "kits-shop") {
        //     $("#kitsContainer").show();
        //     $("#kitsDetailsContainer").hide();
        // }

        $(".dropdown").removeClass("dropdown--active");
    }

    logout(e) {
        e.preventDefault();

        const { logout, history, setAuthenticated, initializeEligibilityModal } = this.props;

        initializeEligibilityModal(false);

        history.push("/");

        logout(() => setAuthenticated(false));
    }

    renderMenuOptions() {
        const { isAuthenticated, topics, categories, newProducts } = this.props;
        const localCategories = _.filter(categories, c => c.includeInTopMenu);

        if (isAuthenticated) {
            _.each(topics, topic => {
                if (topic.systemName.includes("/")) {
                    // eslint-disable-next-line prefer-destructuring
                    const parentCategoryNameArr = topic.systemName.split("/");
                    const [parentCategoryName] = parentCategoryNameArr;

                    const parentCategory = _.find(localCategories, c => c.seName.toLowerCase() === parentCategoryName.toLowerCase());

                    if (parentCategory) {
                        if (!Array.isArray(parentCategory.subCategories)) {
                            parentCategory.subCategories = [];
                        }

                        const subCategory = _.find(parentCategory.subCategories, sc => sc.id === topic.id);

                        if (!subCategory) {
                            parentCategory.subCategories.push({
                                id: topic.id,
                                name: topic.title,
                                url: topic.systemName,
                                subCategories: []
                            });
                        }
                    }
                }
            });

            if (newProducts && newProducts.length > 0) {
                localCategories.splice(2, 0, {
                    id: -1,
                    name: "Featured Products",
                    url: Constants.ENDPOINTS.FEATURED_PRODUCTS.substr(1, Constants.ENDPOINTS.FEATURED_PRODUCTS.length - 1),
                    subCategories: []
                });
            }

            return (
                <ul className="menu-horizontal text-left nav-options">
                    <li>
                        <a href="#" onClick={e => {
                            e.preventDefault();
                            this.onTabClick("");
                        }}>
                            <Translate value="home.tabName" />
                        </a>
                    </li>

                    {_.map(localCategories, category => {
                        if (category.subCategories.length > 0) {
                            return (
                                <li key={category.id} className="dropdown">
                                    <span className="dropdown__trigger">{category.name}</span>
                                    <div className="dropdown__container">
                                        <div className="container">
                                            <div className="row">
                                                <div className="dropdown__content" style={{ minWidth: 190 }}>
                                                    <ul className="menu-vertical">
                                                        {_.map(category.subCategories, subCategory => {
                                                            if (!subCategory.url) {
                                                                return (
                                                                    <li key={subCategory.id}>
                                                                        <a href="#" onClick={e => {
                                                                            e.preventDefault();
                                                                            this.onTabClick(subCategory.seName);
                                                                        }}>
                                                                            {subCategory.name}
                                                                        </a>
                                                                    </li>
                                                                );
                                                            } else {
                                                                return (
                                                                    <li key={subCategory.id}>
                                                                        <a href="#" onClick={e => {
                                                                            e.preventDefault();
                                                                            this.onTabClick(subCategory.url);
                                                                        }}>
                                                                            {subCategory.name}
                                                                        </a>
                                                                    </li>
                                                                );
                                                            }
                                                        })}
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            );
                        }

                        if (!category.url) {
                            return (
                                <li key={category.id}>
                                    <a href="#" onClick={e => {
                                        e.preventDefault();
                                        this.onTabClick(category.seName);
                                    }}>
                                        {category.name}
                                    </a>
                                </li>
                            );
                        } else {
                            return (
                                <li key={category.id}>
                                    <a href="#" onClick={e => {
                                        e.preventDefault();
                                        this.onTabClick(category.url);
                                    }}>
                                        {category.name}
                                    </a>
                                </li>
                            );
                        }
                    })}
                </ul>
            );
        }
    }

    changeLanguage(language) {
        const { getXsrfToken, setLanguage, config } = this.props;

        $(".dropdown").removeClass("dropdown--active");

        getXsrfToken(({ token }) => {
            const obj = {
                __RequestVerificationToken: token,
                language: language
            };

            setLanguage(obj, location, config, true);
        });
    }

    changeCurrency(currency) {
        const { getXsrfToken, setCurrency, config } = this.props;

        $(".dropdown").removeClass("dropdown--active");

        getXsrfToken(({ token }) => {
            const obj = {
                __RequestVerificationToken: token,
                currency: currency
            };

            setCurrency(obj, location, config, true);
        });
    }

    renderAccountOptions(name) {
        const { userInfo, languages, currencies, activeLanguage, activeCurrency } = this.props;

        if (userInfo) {
            return (
                <ul className="menu-horizontal">
                    {/* {infoResult.isGuest && <li>*/}
                    {/* <CreateAccountModal name={name}/>*/}
                    {/* </li>}*/}

                    {languages && languages.length > 1 &&
                    <li className="dropdown dropdown--absolute">
                        <span className="dropdown__trigger">
                            <ReactCountryFlag code={activeLanguage.flag} svg />
                        </span>
                        <div className="dropdown__container">
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-2 dropdown__content">
                                        <ul className="menu-vertical text-left">
                                            {this.renderLanguages()}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>}

                    {currencies && currencies.length > 1 &&
                    <li className="dropdown dropdown--absolute">
                        <span className="dropdown__trigger">{activeCurrency.currencyCode}</span>
                        <div className="dropdown__container">
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-2 dropdown__content">
                                        <ul className="menu-vertical text-left">
                                            {this.renderCurrencies()}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>}

                    <li className="dropdown dropdown--absolute">
                        {userInfo.isGuest
                            ? <span className="dropdown__trigger">{`${userInfo.employeeId}`}</span>
                            : <span className="dropdown__trigger">{`${userInfo.firstName} ${userInfo.lastName}`}</span>}
                        <div className="dropdown__container">
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-1 dropdown__content" style={{ minWidth: 160 }}>
                                        <ul className="menu-vertical text-left">
                                            <li>
                                                <a href="customer"><Translate value="navMenu.profile" /></a>
                                            </li>
                                            <li>
                                                <a href="#" onClick={this.logout}><Translate value="navMenu.logout" /></a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            );
        }
    }

    renderLanguages() {
        const { languages } = this.props;

        if (languages && languages.length > 1) {
            return _.map(languages, lg => (
                <li key={lg.id}>
                    <a href="#" onClick={e => {
                        e.preventDefault();
                        this.changeLanguage(lg);
                    }}>{lg.name}</a>
                </li>
            ));
        }
    }

    renderCurrencies() {
        const { currencies } = this.props;

        if (currencies && currencies.length > 1) {
            return _.map(currencies, c => (
                <li key={c.id}>
                    <a href="#" onClick={e => {
                        e.preventDefault();
                        this.changeCurrency(c);
                    }}>{c.name}</a>
                </li>
            ));
        }
    }

    render() {
        return <div className="nav-container ">
            <div className="bar bar--sm visible-xs">
                <div className="container">
                    <div className="row">
                        <div className="col-5 col-md-2">
                            <a to="#" className="hamburger-toggle toggled-class" onClick={this.toggleMenu}>
                                <i className="icon icon--sm stack-interface stack-menu"/>
                            </a>
                        </div>
                        <div className="col-7 col-md-10 text-right">
                            {this.renderAccountOptions("mobile")}
                        </div>
                    </div>
                </div>
            </div>

            <nav id="menu1" className="bar bar--sm bar-1 hidden-xs">
                <div className="container">
                    <div className="row">
                        <div className="col-md-9 ">
                            <div className="bar__module" style={{ marginLeft: "0px" }}>
                                {/* <div className="hidden-xs">
                                    <Link to="/">
                                        <img className="logo velsol-logo" alt="logo" src={require("../../../Assets/Images/logo-velocitor-white.png")} />
                                    </Link>
                                </div> */}
                                {/* <div id="navbarDropdown" className="collapse navbar-collapse"> */}
                                {this.renderMenuOptions()}
                                {/* </div> */}
                            </div>
                        </div>
                        <div className="col-md-3 text-right hidden-xs">
                            {this.renderAccountOptions("desktop")}
                        </div>
                    </div>
                </div>
            </nav>

        </div>;
    }
}

function mapStateToProps(state) {
    return {
        config: state.config,
        currencies: state.currencies,
        languages: state.languages,
        activeLanguage: state.activeLanguage,
        activeCurrency: state.activeCurrency,
        tempCart: state.tempCart,
        userInfo: state.userInfo,
        isAuthenticated: state.isAuthenticated,
        topics: state.topics,
        categories: state.categories,
        newProducts: state.newProducts
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getXsrfToken: getXsrfToken,
        setCurrency: setCurrency,
        setLanguage: setLanguage,
        logout: logout,
        setAuthenticated: setAuthenticated,
        setWizardInProgressData: setWizardInProgressData,
        updateWizardInProgressModalState: updateWizardInProgressModalState,
        initializeEligibilityModal: initializeEligibilityModal,
        setSelectedDeviceProductId: setSelectedDeviceProductId,
        setSelectedKitProductId: setSelectedKitProductId
    }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NavMenu));